<template>
  <EIcon
    icon="highlight-star"
    size="s"
    class="personal-counter-indicator__icon"
  />
</template>

<script>
import EIcon from '~~/common/vue/components/icon';

export default {
  name: 'EPersonalCounterIndicator',
  components: {
    EIcon,
  },
};
</script>

<style lang="scss" scoped>
.personal-counter-indicator__icon {
  color: $c-red-30;
  z-index: $z-index-l;
  position: absolute;
  right: 3px;
  top: 3px;
}
</style>
